module.exports = __webpack_public_path__ + "img/618.bee1e207.jpg";